module.exports = __webpack_public_path__ + "static/media/popo.ff21e7dc.mp3";